module.exports = __webpack_public_path__ + "img/appBarMovile.83b9800d.png";